import { render, staticRenderFns } from "./TCProblemasDePago.vue?vue&type=template&id=1477b1ca"
import script from "./TCProblemasDePago.vue?vue&type=script&lang=js"
export * from "./TCProblemasDePago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports